import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { AltraParte } from '../models/altraparte';
import { Controparte } from '../models/controparte';
import { SezioneAltrePartiResponse } from '../models/dto/sezione-altre-parti-response';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { Reato } from '../models/reato';
import { SezioneAltreParti } from '../models/sezioni/sezione-altre-parti';
import { SezioneControparti } from '../models/sezioni/sezione-controparti';
import { TipoGenericoRimovibile } from '../models/tipologiche/tipo-generico-rimovibile';
import { BaseForm } from './base-Form';
import { ReatoAdapter } from '../components/fascicolo/reati-edit/reato-adapter';
import { ParteReato } from '../models/parte-reato';
import { ParteReatoArray } from '../models/parte-reato-array';
import { idAltrePartiInTipoParte, idControparteInTipoParte, tipiParteReatoOptions } from '../models/tipologiche/mock-tipo-parte-reato';
import { DatiReato } from '../models/dati-reato';
import { Persona } from '../models/persona';

@Component({
    selector: 'div [reato-form]',
  templateUrl: 'reato-form.html'
})

export abstract class ReatoForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  request: Reato;
  reatoForm: FormGroup;
  tipoParte: TipoGenericoRimovibile = null;
  parte: ParteReatoArray = null;
  msgNoParti: string;
  foundIndagatoImputato: boolean = false;
  reati: DatiReato[] = [];
  indexToEdit: number | null = null;

  // options
  parteView: ParteReato;
  partiAll: ParteReatoArray[] = [];

  altrePartiAll: AltraParte[] = [];
  contropartiAll: Controparte[] = [];
  tipiPartiOptions: TipoGenericoRimovibile[] = [] ;
  partiOptions: ParteReatoArray[] = [] ;
  sections: {altreParti: boolean; controparti: boolean} = {altreParti: false, controparti: false};

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;

  // private idTipoPersonaFisica: string = PropertiesSettings.ID_TIPO_PERSONA_FISICA;
  // private idTipoPersonaGiuridica: string = PropertiesSettings.ID_TIPO_PERSONA_GIURIDICA;

  abstract getReato(): Reato;
  abstract getRequest(request: Reato);
  abstract getUrlReadSezioneAltreParti(): string;
  abstract getUrlReadSezioneControparti(): string;

  constructor(protected operationService: OperationsService,
              private campiForm: FormBuilder,
              private helpers: HelpersService) {
                super();
  }

 initRequest() {
    this.request = new ReatoAdapter(this.getReato()).reato;
    this.initViewToggle();
    
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.indexToEdit = null;
    this.parteView = null;
    this.partiAll = [];
    this.altrePartiAll = [];
    this.contropartiAll = [];
    this.tipiPartiOptions = [];
    this.partiOptions = [];
    this.sections = { altreParti: false, controparti: false };
    this.foundIndagatoImputato = false;
    this.msgNoParti = null;

    this.initRequest();
    this.reati = [];
    if (!this.inserimento && this.request && Array.isArray(this.request.datiReato)) {
      this.reati = this.request.datiReato.map(r => Object.assign({}, r));
    }

    this.reatoForm = this.campiForm.group({
        id: [this.request.id],
        datiReato: this.campiForm.array([
            this.campiForm.group({
                id: [''], 
                articolo: ['', Validators.required], 
                dataReato: [null, Validators.required],
                luogoReato: ['Napoli', Validators.required],
                note: ['']
            })
        ])
    });
  }

  populateSelect() {
    if (this.tipiPartiOptions.length === 0) {
      let tipiPartiOptionsAppoggio:  TipoGenericoRimovibile[] = <TipoGenericoRimovibile[]> JSON.parse(JSON.stringify(tipiParteReatoOptions));
      for (let tipoParte of tipiPartiOptionsAppoggio) {
        tipoParte.rimosso = this.checkTipoPartePresente(tipoParte.id);
      }
      this.tipiPartiOptions = tipiPartiOptionsAppoggio;
    }
    if (this.request && this.request.controparte) {
      for (let tipo of tipiParteReatoOptions) {
        if (tipo.id === idControparteInTipoParte) {
          this.tipoParte = tipo;
        }
      }
      this.partiOptions = this.partiAll.filter(parte => { return parte.parteReato.tipoParteReato.id === idControparteInTipoParte; });
      for (let parte of this.partiOptions) {
        if (parte.parteReato.persona.id === this.request.controparte.parte.id) {
          this.parte = parte;
        }
      }
    }
    // if (this.request && this.request.altraParte) {
    //   for (let tipo of tipiParteReatoOptions) {
    //     if (tipo.id === idAltrePartiInTipoParte) {
    //       this.tipoParte = tipo;
    //     }
    //   }
    //   this.partiOptions = this.partiAll.filter(parte => { return parte.parteReato.tipoParteReato.id === idAltrePartiInTipoParte; });
    //   for (let parte of this.partiOptions) {
    //     if (parte.parteReato.persona.id === this.request.altraParte.parte.id) {
    //       this.parte = parte;
    //     }
    //   }
    // }
  }

  readSezioneAltreParti(idSezioneAltreParti: string) {
    if (idSezioneAltreParti) {
      this.operationService.readSezione(this.getUrlReadSezioneAltreParti(), idSezioneAltreParti)
        .subscribe(response => this.readSezioneAltrePartiResponse((<SezioneAltrePartiResponse>response).sezione));
    } else {
      this.sections.altreParti = true;
    }
  }

  readSezioneAltrePartiResponse(sezioneAltreParti: SezioneAltreParti) {
    this.altrePartiAll = sezioneAltreParti.altreParti;

    // Filtro per categoriaAltraParte == 'INDAGATO/IMPUTATO'
    this.altrePartiAll = this.altrePartiAll.filter(altraParte => {
        return altraParte.categoriaAltraParte?.label ===  'INDAGATO/IMPUTATO';
    });

    if (this.altrePartiAll.length > 0) {
      this.foundIndagatoImputato = true; // Abbiamo trovato parti con questa categoria
    }

    for (let altraParte of this.altrePartiAll) {
        let parteNew: ParteReato = new ParteReato();
        parteNew.idParent = altraParte.id;
        parteNew.tipoParteReato = tipiParteReatoOptions.filter(tB => { return tB.id === idAltrePartiInTipoParte; })[0];
        parteNew.persona = altraParte.parte;
        parteNew.categoria = altraParte.categoriaAltraParte?.label || '';
        let parteNewArray = this.getParteReatoArray(parteNew);
        this.partiAll.push(parteNewArray);
    }

    this.sections.altreParti = true;

    if (this.sections.altreParti && this.sections.controparti) {
      this.checkNoIndagatoImputato();
  }

}


  readSezioneControparti(idSezioneControparti: string) {
    if (idSezioneControparti) {
      this.operationService.readSezione(this.getUrlReadSezioneControparti(), idSezioneControparti)
        .subscribe(response => this.readSezioneContropartiResponse((<SezioneContropartiResponse>response).sezione));
    } else {
      this.sections.controparti = true;
    }
  }

  readSezioneContropartiResponse(sezioneControparti: SezioneControparti) {
    this.contropartiAll = sezioneControparti.controparti;
    // Filtro per categoria.label == 'INDAGATO/IMPUTATO'
    this.contropartiAll = this.contropartiAll.filter(controparte => {
      return controparte.categoria?.label === 'INDAGATO/IMPUTATO';
    });
    if (this.contropartiAll.length > 0) {
      this.foundIndagatoImputato = true; // Abbiamo trovato controparti con questa categoria
    }
    for (let controparte of this.contropartiAll) {
        let parteNew = new ParteReato();
        parteNew.idParent = controparte.id;
        parteNew.tipoParteReato = tipiParteReatoOptions.filter(tB => { return tB.id === idControparteInTipoParte; })[0];
        parteNew.categoria = controparte.categoria?.label || '';
        parteNew.persona = controparte.parte;
        let parteNewArray = this.getParteReatoArray(parteNew);
        this.partiAll.push(parteNewArray);
    }
    this.sections.controparti = true;
    // if (this.sections.altreParti && this.sections.controparti) {
    //   this.checkNoIndagatoImputato();
    // }
    if (this.sections.controparti) {  
      this.populateSelect();
      this.checkNoIndagatoImputato();
    }
  }

  checkNoIndagatoImputato() {
    // Se nessuna parte o controparte ha la categoria 'INDAGATO/IMPUTATO'
    if (!this.foundIndagatoImputato) {
        this.msgNoParti = 'Non ci sono parti con categoria INDAGATO/IMPUTATO';
    }
  }


  checkTipoPartePresente(idTipoParte: string): boolean {
    if (this.partiAll.length > 0) {
      return this.partiAll.filter(parte => { return parte.parteReato.tipoParteReato.id === idTipoParte; }).length === 0;
    }
    return true;
  }

  aggiungi() {
    if (this.reatoForm.valid) {
      const nuovoReato: DatiReato = this.reatoForm.value.datiReato[0];

      if (this.indexToEdit !== null && this.indexToEdit !== undefined) {
        this.reati[this.indexToEdit] = nuovoReato;
        this.indexToEdit = null;
      } else {
        this.reati.push(nuovoReato);
      }

      this.reatoForm.reset();
      this.reatoForm.patchValue({ datiReato: [{ luogoReato: 'Napoli' }] });
    }
  }

  modifica(index: number) {
    const reatoDaModificare = this.reati[index];
    this.reatoForm.patchValue({
      id: reatoDaModificare.id,
      datiReato: [{
        id: reatoDaModificare.id,
        articolo: reatoDaModificare.articolo,
        dataReato: reatoDaModificare.dataReato,
        luogoReato: reatoDaModificare.luogoReato,
        note: reatoDaModificare.note
      }]
    });
    this.indexToEdit = index;
  }


  elimina(index: number) {
    this.reati.splice(index, 1);
  }

  save() {
    this.request.datiReato = this.reati.map(r => Object.assign({}, r));
    this.getRequest(this.request);
  }

  private getParteReatoArray(parteNew: ParteReato): ParteReatoArray {
    let parteNewArray = new ParteReatoArray();
    parteNewArray.parteReato = parteNew;
    parteNewArray.id = parteNew.persona.id;
    return parteNewArray;
  }

  goToAssocia() {
    this.reati = [];
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  setParte(reatoArray: ParteReatoArray) {
    let parte: ParteReato = reatoArray.parteReato;
    this.request.controparte = null;
    //this.request.altraParte = null;
    if (parte.tipoParteReato.id === idControparteInTipoParte) {
      this.request.controparte =  this.contropartiAll.filter(controparte => { return controparte.id === parte.idParent; })[0];
    }
    // if (parte.tipoParteReato.id === idAltrePartiInTipoParte) {
    //   this.request.altraParte =  this.altrePartiAll.filter(altraParte => { return altraParte.id === parte.idParent; })[0];
    // }
    this.parteView = parte;
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }


  reset() {
    const defaultReato: DatiReato = {
      id: '',
      articolo: '',
      dataReato: null,
      luogoReato: 'Napoli',
      note: ''
    };

    // Se sono in inserimento -> pulisco solo il form (mantengo this.reati così com'è)
    if (this.inserimento) {
      this.reatoForm.reset();
      this.reatoForm.patchValue({ datiReato: [defaultReato] });
      this.indexToEdit = null;
      return;
    }

    // Sono in modifica -> lavoro sul temporaneo this.reati
    const datiReatoArray = Array.isArray(this.reati) ? this.reati : [];

    // Se indexToEdit è impostato -> voglio ripristinare il form con quell'elemento
    const isNuovoReato = this.indexToEdit === null || this.indexToEdit === undefined;
    const datiReato = !isNuovoReato && datiReatoArray[this.indexToEdit]
      ? datiReatoArray[this.indexToEdit]
      : defaultReato;

    this.reatoForm.reset();
    this.reatoForm.patchValue({
      id: this.request?.id || '',
      datiReato: [{
        id: datiReato.id || '',
        articolo: datiReato.articolo || '',
        dataReato: datiReato.dataReato || null,
        luogoReato: datiReato.luogoReato || 'Napoli',
        note: datiReato.note || ''
      }]
    });
  }


  getParteReato(reato: Reato): Persona {
    if (reato.controparte) {
      return reato.controparte.parte;
    }
  }

}
